<section class="hero-section">
  <div class="hero-content">
    <h1 class="hero-title">
      <span class="hero-title-line">Choose your <span class="apps-highlight">Apps</span></span>
    </h1>
    <p class="hero-description">
      Free instant access. No credit card required.
    </p>
  </div>
</section>
